<template>
    <v-dialog v-model="isShow" persistent width="400" >
        <v-card class="pa-0" color="teal lighten-4" >
            <v-card-text class="pa-0">
                <!-- <table style="width:100%">
                    <tr>
                        <td style="width:100%; text-align:center" class="white--text">
                            <h2>{{processingMessage}}</h2>
                        </td>
                    </tr>
                    <tr>
                        <td style="width:100%; text-align:center">
                            <v-progress-circular
                                indeterminate
                                color="white"
                                class="ma-3"
                                />
                        </td>
                    </tr>
                </table> -->
                <div style="width:400px; vertical-align:middle; display:table-cell; height:100px;">
                <table style="margin:auto">
                    <tr>
                        <td>
                            <v-progress-circular
                                indeterminate
                                color="white"
                                class="ma-3"
                                />
                        </td>
                        <td style="white-space:normal">
                            <h2>{{processingMessage}}</h2>
                        </td>
                    </tr>
                </table>
                </div>
                <!-- <div style="width:400px; text-align:center; vertical-align:middle; display:table-cell; height:100px; position:relative">
                    <v-progress-circular
                        indeterminate
                        color="white"
                        class="ma-3"
                        />
                    <h2>{{processingMessage}}</h2>
                </div>                     -->
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        computed: {
            isProcessing: function () {
                return this.$store.getters["processing"]
            },
            processingMessage: function () {
                return this.$store.getters["processingMessage"]
            }
        },
        watch: {
            isProcessing: function (value) {
                if (value == true) {
                    this.isShow = true
                } else {
                    this.isShow = false
                }
            },
        },
        data: function () {
            return {
                isShow: false
            }
        }
    }
</script>
